import React, { forwardRef } from 'react'
import { FieldError } from 'react-hook-form'

import styles from './common-textarea.module.scss'

import { c } from '#/shared/lib/helpers'

export type TextAreaVariant = 'default' | 'outline'

export interface CommonTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	children?: React.ReactNode
	variant?: TextAreaVariant
	label?: string | React.ReactNode
	error?: FieldError
	buttomSlot?: React.ReactNode
	trim?: boolean
	showError?: boolean
}

// Извлекаем стили для textarea (только тёмная тема)
const getTextareaStyles = (error?: FieldError) => {
	return {
		wrapper: {
			backgroundColor: '#151518',
			borderRadius: '15px',
			border: `2px solid ${error ? '#ff2372' : '#40404E'}`,
		},
		textarea: {
			color: '#E1E1E1',
			fontWeight: 500,
		},
	}
}

export const CommonTextArea = forwardRef<HTMLTextAreaElement, CommonTextAreaProps>(
	({ showError = true, buttomSlot, label, error, className, disabled, trim = false, variant = 'default', ...props }, ref) => {
		const themeStyles = getTextareaStyles(error)

		const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
			if (props.onChange) {
				props.onChange(event)
			}
			if (trim) {
				event.target.value = event.target.value.trim()
			}
		}

		return (
			<div className={c(styles.box, className)}>
				<div className={styles.header}>
					{label && <label className={c(styles.label, error && styles.label_error)}>{label}</label>}
				</div>
				<div
					className={c(
						styles.wrapper,
						disabled && styles.wrapper_disabled,
						error && styles.wrapper_error
					)}
					style={themeStyles.wrapper}
				>
					<textarea
						ref={ref}
						style={themeStyles.textarea}
						className={c(
							styles.textarea,
							disabled && styles.textarea_disabled,
							error && styles.textarea_error
						)}
						onChange={onChange}
						disabled={disabled}
						{...props}
					/>
					{buttomSlot}
				</div>
				{showError && <p className={c(styles.header__error, error && styles.header__error_visible)}>{error ? error?.message : ''}</p>}
			</div>
		)
	}
)

CommonTextArea.displayName = 'CommonTextArea'